import { Stack, Typography } from "@mui/material";
import { FieldConfigurationType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MeasureDrillDownInfo } from "../../../../../../../../api/types/svTypes.ts";
import type { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import { getActiveLayer } from "../../../../store/utils/getActiveLayer.ts";
import SourceColumnLinks from "./SourceColumnLinks.tsx";

interface Props {
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo;
}

export default function PageTitle({ configuration, info }: Props) {
  const activeLayer = getActiveLayer(configuration);
  const measure = activeLayer.measure;
  const sourceFields = info.valueTargetFields ?? [];
  const fieldSubCaption = getFieldSubCaption(configuration);
  const measureCaption = measure?.config.customLabel || measure?.config.systemLabel || measure?.meta.caption;
  const cellValue = activeLayer.formattedValue ?? activeLayer.cell.formattedValue;

  return (
    <Stack sx={{ py: 1.25, gap: 0.25 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {measureCaption}
      </Typography>
      <Stack direction="row" sx={{ gap: 1, alignItems: "center", flexWrap: "wrap" }}>
        {cellValue && (
          <Typography variant="body2" color="textSecondary">
            {cellValue}
          </Typography>
        )}
        {sourceFields.length > 0 && (
          <Typography variant="body2" color="textSecondary">
            <SourceColumnLinks fields={sourceFields} />
            {fieldSubCaption}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

function getFieldSubCaption(configuration: DrillDownPage) {
  const measure = getActiveLayer(configuration).measure;
  if (measure?.config.type === FieldConfigurationType.Irr) {
    return ` • ${measure.config.cashFlowFrequency}`;
  }
  return "";
}
